export const setHashPath = (path: string) => {
  localStorage.setItem('lastRoute', path);
}
